import React from 'react';
import { renderRoundLabel } from '../../utils/draws';

import styles from './drawEdit.scss';

const DrawsSubHeaderV2 = (props) => {
    const { draw, currentDraw, updateSelectedRound, selectedRound, disableNextButton, isCutOffRound, activeView } = props;

    return (
        <div className={`${styles.section} sub-header`}>
            <div className="container">
                <div className="row">
                    <div className="col-md-4" />
                    {draw && activeView === 'drawEditor' && currentDraw && draw.rounds?.length > 0 && (
                        <>
                            <div className="col-md-4 draws-round d-none d-lg-block">
                                <div className="text-semi text-dark text-center lh36 p-rel" data-testid={`draw-edit.sub-header.round-${selectedRound + 1}-label`}>{renderRoundLabel(draw.rounds[selectedRound], draw.eliminationTypeId, draw.categoryTypeId, draw.rounds[selectedRound + 1])}
                                    <div className={`click-area click-area-36 float-left ${selectedRound === 0 ? 'disabled' : ''}`} onClick={() => updateSelectedRound('down')} data-testid={`draw-edit.sub-header.round-${selectedRound + 1}-prev-btn`}>
                                        <i className={`uts uts-prev`} />
                                    </div>
                                </div>
                            </div>
                            {draw.rounds[selectedRound + 1] && !isCutOffRound(selectedRound + 1) && (
                                <div className="col-md-4 draws-round d-none d-lg-block">
                                    <div className="text-semi text-dark text-center lh36 p-rel" data-testid={`draw-edit.sub-header.round-${selectedRound + 2}-label`}>{renderRoundLabel(draw.rounds[selectedRound + 1], draw.eliminationTypeId, draw.categoryTypeId, draw.rounds[selectedRound + 2])}
                                        <div
                                            className={`click-area click-area-36 float-right ${disableNextButton() ? 'disabled' : ''}`}
                                            onClick={() => {
                                                if (!disableNextButton()) {
                                                    updateSelectedRound('up', draw.rounds.length);
                                                }
                                            }}
                                            data-testid={`draw-edit.sub-header.round-${selectedRound + 2}-next-btn`}
                                        >
                                            <i className={`uts uts-next`} />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DrawsSubHeaderV2;
